// extracted by mini-css-extract-plugin
module.exports = {"container":"Ei","addToButton":"Fi","basic":"Gi","disabled":"Hi","m-heart-activate":"Ii","lists":"Ji","addNew":"Ki","m-heart-pulse":"Li"};